import classes from "./WelcomeMessage.module.css";
import apple from "./../../../assets/images/apple.png";
import android from "./../../../assets/images/android.png";
import information from "./../../../assets/images/information_project.png";
import espa from "./../../../assets/images/ellada2_0.png";
import sponsor from "./../../../../SMARTCITY/assets/images/sponsor.png";
import { useTranslation } from "react-i18next";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
  welcomeMessageContent,
} from "../../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../../hooks/language-context";
import styled from "styled-components";

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);
  return (
    <WelcomeMessageContainer>
      <div style={{ lineHeight: "1.5" }}>
        <p>{t("welcomeMessageContent.part1")}</p>
        <p>{t("welcomeMessageContent.part2")}</p>
      </div>
      <div>
        <div
          style={{
            width: "336px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <img
            src={apple}
            alt={"apple-application"}
            width={166}
            onClick={() => window.open(iosAppLink)}
          />
          <img
            src={android}
            alt={"android-application"}
            width={166}
            onClick={() => window.open(androidAppLink)}
          />
        </div>
        <a href="https://greece20.gov.gr/" target="_blank">
          <img
            src={espa}
            alt="sponsor logo"
            style={{
              maxWidth: "100%",
              height: "auto",
              padding: "6px 8px",
              background: "#fff",
              marginTop: "10px",
            }}
          />
        </a>
      </div>
    </WelcomeMessageContainer>
  );
};

export default WelcomeMessage;

const WelcomeMessageContainer = styled.div`
  width: 320px;
  color: white;
  padding: 20px 20px;
  // line-height: 1.5;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 908px) {
    padding: 20px 0;
    width: 100%;
    align-items: center;
    gap: 20px;
    height: fit-content;
    text-align: center;

    img {
      width: 266px;
    }
  }
`;
